import { UserRightsPanel } from '@monorepo/shared-lib';
import { ProviderIcon } from 'components/Custom/ProviderIcon';
import { UpgradeMessage } from 'containers/UpgradeMessage';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TablePermission, UpgradeMessageSource } from 'store/api/enums';
import { turnModalOff, turnModalOn } from 'store/app/actions';
import { WindowType } from 'store/app/enums';
import { getAuthUser } from 'store/auth/selectors';
import { AdvancedUserRights, UserRights } from 'store/user/models';

interface RightsProps {
  loading: boolean;
  rights?: UserRights[];
  saveUserRights: (
    userRight: UserRights,
    tablePermission: TablePermission
  ) => void;
  saveAllUserRights: (
    userRight: UserRights[],
    tablePermission: TablePermission
  ) => void;
  onClose: () => void;
  entities?: unknown;
  isAdvancedUserRights?: boolean;
  advancedUserRights?: AdvancedUserRights[];
  setAdvancedUserRight?: (
    accountUuid: string,
    organisationId: string,
    operationIds: string[]
  ) => void;
  setAdvancedUserRightToAll?: (
    accountUuid: string,
    organisationIds: string[],
    operationIds: string[]
  ) => void;
}

export const Rights: React.FC<RightsProps> = ({
  loading,
  rights,
  saveUserRights,
  saveAllUserRights,
  onClose,
  isAdvancedUserRights,
  advancedUserRights,
  setAdvancedUserRight,
  setAdvancedUserRightToAll,
}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector(getAuthUser);

  return (
    <UserRightsPanel
      loading={loading}
      rights={rights}
      saveUserRights={saveUserRights}
      saveAllUserRights={saveAllUserRights}
      onClose={onClose}
      isAdvancedUserRights={isAdvancedUserRights}
      advancedUserRights={advancedUserRights}
      setAdvancedUserRight={setAdvancedUserRight}
      setAdvancedUserRightToAll={setAdvancedUserRightToAll}
      onUpgradeClick={() =>
        dispatch(
          turnModalOn({
            title: '',
            type: WindowType.WARNING,
            component: (
              <UpgradeMessage
                source={UpgradeMessageSource.ADVANCED_USER_RIGHTS}
                onClose={() => dispatch(turnModalOff())}
                userAccountType={currentUser?.accountType}
              />
            ),
          })
        )
      }
      renderProviderIcon={(providerName) => (
        <ProviderIcon providerName={providerName} width={32} height={32} />
      )}
    />
  );
};
